import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import KivaProxy from "@/utils/kivaProxy/src";
import showUsers from "@/components/tasks/user/show_users.vue";
import moment from "moment";
var requests = require("@/utils/requests").default;
import { NoteTransformer } from "@/transformers/NoteTransformer";
import attachmentMixin from "@/mixins/attachment.js";
export default {
  mixins: [attachmentMixin],
  props: {
    name: "KvNoteList",
    id: [String, Number],
    endpoint: String,
    formPosition: {
      type: String,
      default: "top"
    },
    maxHeight: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    formFixed: {
      type: Boolean,
      default: false
    },
    formStyle: {
      type: Object,
      default: {
        width: "343px",
        bottom: 0
      }
    },
    formBorder: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    fixedHeight: {
      type: String,
      default: ""
    },
    formRadiusClass: {
      type: String,
      default: "kv-radius-default"
    },
    showAvatar: {
      type: Boolean,
      default: false
    },
    col: {
      type: [Array, Object],
      default: function _default() {
        return {
          form: 24,
          list: 24,
          gutter: 6
        };
      }
    }
  },
  created: function created() {
    moment.locale(this.$locale);
    this.listAll();
  },
  components: {
    vueMention: function vueMention() {
      return import("@/components/tasks/main/widgets/vue_mention");
    },
    showUsers: showUsers
  },
  computed: {
    getEndpoint: function getEndpoint() {
      return this.endpoint + "/" + this.id + "/note";
    },
    app: function app() {
      var endpoint = this.endpoint.split("/");
      return endpoint[0];
    },
    model: function model() {
      var endpoint = this.endpoint.split("/");
      return endpoint[1];
    }
  },
  data: function data() {
    return {
      notes: [],
      selectedNote: {},
      focus: false,
      show_mention: false,
      any_change: false,
      new_note: {
        message: "",
        attachments: [],
        note_id: "0"
      },
      files: [],
      NewNoteKey: "note",
      loading: false
    };
  },
  methods: {
    delete_attachment: function delete_attachment(img) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var endpoint;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // let model = img.model ? img.model : this.model;
              // let app = img.app ? img.app : this.app;

              img.record_id = _this.id;
              endpoint = _this.endpoint.split("/");
              img.model = endpoint[1];
              img.app = endpoint[0];
              _this.$confirm(_this.$t('This will permanently delete the file. Continue?'), _this.$t('Warning'), {
                confirmButtonText: _this.$t("Ok"),
                cancelButtonText: _this.$t("Cancel"),
                type: "warning"
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var rtn;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return requests.delete_attachment({
                        attachment_id: img.file_id,
                        record_id: img.record_id,
                        model: img.model,
                        app: img.app
                      });
                    case 2:
                      rtn = _context.sent;
                      img.name = "";
                      Object.assign(img, {});
                      if (rtn.status == "Success") {
                        // this.getNotes();
                        _this.saveNote();
                        _this.$message({
                          type: "success",
                          message: _this.$t("Delete completed")
                        });
                      } else {
                        _this.$message({
                          type: "info",
                          message: _this.$t('Delete could not complete.')
                        });
                      }
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))).catch(function (err) {
                console.log(err);
                _this.$message({
                  type: "info",
                  message: _this.$t("Delete canceled")
                });
              });
              // this.is_delete_attachment = false;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleView: function handleView(att) {
      var record_id = this.id;
      var endpoint = this.endpoint.split("/");
      var model = endpoint[1];
      var app = endpoint[0];
      var r = "".concat(this.$kvAttachmentViewPath, "?app=") + app + "&model=" + model + "&record_id=" + record_id + "&file_name=" + att.name + "&file_type=" + att.file_type + "&uid=" + att.file_id + "&_blank=1&_csrf=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOjI5MzI0LCJleHAiOjE1ODQ1MDA4Mjl9.Hb-ptWmjnoDhg7sGkXa2PDjJQ-K0UpoU6fjVEi7MAh4";
      var viewer = this.$el.querySelector(".viewer-".concat(att.file_id)).$viewer;
      viewer.show();
    },
    uploadAttachment: function uploadAttachment(note, files) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var total, all, say;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(files && files[0] && files[0].name)) {
                _context4.next = 6;
                break;
              }
              total = files.length;
              all = Object.keys(files);
              say = 1;
              _context4.next = 6;
              return all.forEach( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key) {
                  var f, fd, arr_endpoint, rtn, text;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        f = files[key];
                        fd = new FormData();
                        arr_endpoint = _this2.endpoint.split("/");
                        fd.append("file", f.raw, f.name);
                        fd.append("record_id", _this2.id);
                        fd.append("attachment_id", "");
                        _this2.loading = true;
                        _context3.next = 9;
                        return requests.upload_attachments({
                          files: fd,
                          record_id: _this2.id,
                          app: arr_endpoint[0],
                          model: arr_endpoint[1]
                        });
                      case 9:
                        rtn = _context3.sent;
                        note.attachments.push(_objectSpread(_objectSpread({
                          file_id: rtn.records.file_id
                        }, f), {}, {
                          record_id: _this2.id,
                          app: arr_endpoint[0],
                          model: arr_endpoint[1]
                        }));
                        if (say == total) {
                          _this2.saveNote(note);
                          _this2.loading = false;
                          text = "";
                          if (rtn.status == "Success") {
                            _this2.$emit("showAttachments", false);
                          } else {}
                        }
                        say++;
                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    listAll: function listAll() {
      this.getNotes();
    },
    renderMessage: function renderMessage(message) {
      var m = message;
      var arr = m.split("http");

      // "test deneme@test.com  ve ", "s://google.com ve ", "://kiva.cloud"]
      if (arr[1]) {
        arr.forEach(function (a, i) {
          if (i > 0) {
            var url_Arr = a.split(" ");
            var url = url_Arr[0];
            var remainBlock = '';
            if (url_Arr[1]) {
              url_Arr.shift();
              remainBlock = url_Arr.join(" ");
            }
            var tag = '<a href="http' + url + '" target="_blank">http' + url + '</a> ' + remainBlock;
            arr[i] = tag;
          }
        });
      }
      m = arr.join(" ");
      var arr2 = m.split(" ");
      if (arr2[1]) {
        arr2.forEach(function (a, i) {
          // ilk ve son karakter @ değil ama @ varsa
          if (a.includes("@") && a.charAt(0) != "@" && a.slice(-1) != "@") {
            var tag = " " + '<a target="_blank" href="mailto:' + arr2[i] + '" >' + arr2[i] + '</a>';
            arr2[i] = " " + tag;
          } else {
            arr2[i] = " " + arr2[i];
          }
        });
      }
      return arr2.join(" ");
    },
    getNotes: function getNotes() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this3.loading = true;
              _context5.next = 3;
              return new KivaProxy({
                endpoint: _this3.getEndpoint
              }).setSort("note_id").setDir("DESC").all().then(function (notes) {
                _this3.loading = false;
                console.log(notes.data);
                var nt = NoteTransformer.fetchCollection(notes.data);
                _this3.notes = nt.reverse();
              }).finally(function () {
                _this3.loading = false;
              });
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    saveNote: function saveNote(note, files) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var attachments, obj;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(files && files[0] && files[0].name)) {
                _context8.next = 5;
                break;
              }
              _context8.next = 3;
              return _this4.uploadAttachment(note, files);
            case 3:
              _context8.next = 12;
              break;
            case 5:
              _this4.files = [];
              if (!note) {
                note = _this4.selectedNote;
              }
              _this4.loading = true;
              // let stringAttachment = JSON.stringify(note.attachments);

              note.message = note.message;
              attachments = ""; // console.log("note.attachments",note.attachments)
              if (note.attachments) {
                obj = [];
                note.attachments.forEach(function (k) {
                  obj.push(k.file_id);
                });
                attachments = obj.join(",");
              }
              if (note.note_id && note.note_id != "0") {
                new KivaProxy({
                  endpoint: _this4.getEndpoint + "/" + note.note_id
                }).submit("patch", _this4.getEndpoint + "/" + note.note_id, {
                  body: note.message,
                  attachments: attachments
                }).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
                    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _this4.loading = false;
                          note.message = "";
                          note.attachments = [];
                          Object.assign(note.attachments, []);
                          _this4.NewNoteKey = Math.random(9, 99999);
                          _this4.selectedNote = {};
                          _this4.listAll();
                        case 7:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              } else {
                new KivaProxy({
                  endpoint: _this4.getEndpoint
                }).submit("post", _this4.getEndpoint, {
                  body: note.message,
                  attachments: attachments
                }).then( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(response) {
                    var h;
                    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          _this4.loading = false;
                          note.message = "";
                          note.attachments = [];
                          note.note_id = "0";
                          _this4.NewNoteKey = Math.random(9, 99999);
                          _this4.listAll();
                          h = _this4.$createElement;
                        case 7:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7);
                  }));
                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  _this4.loading = false;
                  _this4.$notify({
                    title: _this4.$t("Error"),
                    message: err.description,
                    type: "error"
                  });
                });
              }
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    handleCommand2: function handleCommand2(command) {
      var _this5 = this;
      var note = this.notes[command.i];
      if (command.command == "edit") {
        this.selectedNote = _objectSpread({}, note);
        this.files = [];
      } else if (command.command == "delete") {
        this.$confirm("This will be deleted permanently. Continue?", "Warning", {
          confirmButtonText: this.$t("Ok"),
          cancelButtonText: this.$t("Cancel"),
          type: "warning"
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return new KivaProxy({
                  endpoint: _this5.getEndpoint
                }).destroy(note.note_id).then(function (response) {
                  _this5.files = [];
                  _this5.listAll();
                  _this5.$message({
                    type: "success",
                    message: _this5.$t("Delete completed")
                  });
                }).catch(function () {
                  _this5.$message({
                    type: "info",
                    message: "Delete failed"
                  });
                });
              case 2:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }))).catch(function () {
          _this5.$message({
            type: "info",
            message: _this5.$t("Delete canceled")
          });
        });
      }
    }
  },
  watch: {
    endpoint: "listAll",
    id: "listAll"
  }
};